exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":root {\n  /* color */\n\n  /* font */\n\n  /* link */\n}\n:root {\n  /* цвет */\n\n  /* TODO в фигме другие цвета по названиям scarlet magenta green beeline aquamarine violet, надо решить с дизайнерами  */\n\n  /* токены со ссылкой на глобал цвета */\n\n  /* шрифт */\n\n  /* отступы от шапки и футера до тела страницы */\n\n  /* ширина тела страницы */\n\n  /* отступы между элементами страницы */\n}\n.PopupDescription_component_eLpi {\n  margin-bottom: 32px;\n  padding: 16px;\n\n  display: -webkit-box;\n\n  display: -webkit-flex;\n\n  display: -ms-flexbox;\n\n  display: flex;\n\n  background: #f9f9f9;\n}\n.PopupDescription_image_2rjH {\n  margin-right: 16px;\n}\n", ""]);

// exports
exports.locals = {
	"component": "PopupDescription_component_eLpi",
	"image": "PopupDescription_image_2rjH"
};